import React from "react";
import {
  Image,
  Modal,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppColors } from "../../../../utility/AppColors";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Separator from "../../../../Components/Separator";
import { CommonButton } from "../../../../common/CommonButton";
import { AppImages } from "../../../../utility/AppImages";

const ConnetedPopup = ({ showPopup, closePopup }) => {
  const deviceSize = useDeviceSize();
  return (
    <Modal
      transparent={true}
      visible={showPopup}
      onRequestClose={closePopup}
      animationType="fade"
    >
      <View
        style={{
          flex: 1,
          backgroundColor: "rgba(0, 0, 0, 0.76)",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ScrollView
          contentContainerStyle={{
            paddingHorizontal: 20,
            alignItems: "center",
          }}
        >
          <View
            style={{
              backgroundColor: AppColors.black_121212,
              padding:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? 10
                  : 20,
              marginVertical: 20,
              borderRadius: 10,
              width:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "95%"
                  : "50%",
              alignItems: "center",
              borderWidth: 1,
              borderColor: AppColors.gray_9F9F9F,
            }}
          >
            <View
              style={{
                width: "100%",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Text
                style={[
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? AppFontStyle.BOLD_ANYBODY_16
                    : AppFontStyle.BOLD_ANYBODY_20,
                  { flex: 1 },
                ]}
              >
                Connect To Your Streaming Account
              </Text>
              <TouchableOpacity
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onPress={() => {
                  closePopup();
                }}
              >
                <Image
                  source={AppImages.icCloseWhite}
                  style={{
                    height: 35,
                    width: 35,
                  }}
                />
              </TouchableOpacity>
            </View>
            <Separator
              color={AppColors.appBlackColor_1e1e1e}
              height={2}
              marginTop={10}
              marginBottom={10}
              marginHorizontal={0}
            />
            <View
              style={{
                paddingHorizontal:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? 0
                    : 20,
              }}
            >
              <View
                style={{
                  marginBottom: 20,
                  width:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? "auto"
                      : "100%",

                  backgroundColor: AppColors.appBlackColor_1e1e1e,
                  borderRadius: 10,

                  flexDirection:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? "column"
                      : "row",
                  padding:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? 10
                      : 20,
                  margin:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? 10
                      : 0,
                  justifyContent: "space-between",
                  gap:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? 20
                      : 0,
                }}
              >
                <View
                  style={{
                    width:
                      deviceSize === DEVICE_SIZES.XS ||
                      deviceSize === DEVICE_SIZES.SM
                        ? "100%"
                        : "48%",
                  }}
                >
                  <Image
                    style={{
                      width:
                        deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                          ? 150
                          : 210,
                      height: 67,
                      resizeMode: "contain",
                    }}
                    source={AppImages.twitchStream}
                  />
                  <View style={{ marginTop: 10 }}>
                    <Text
                      style={[
                        deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                          ? AppFontStyle.REGULAR_ANYBODY_12
                          : AppFontStyle.BOLD_ANYBODY_16,
                        { color: AppColors.red_ED1F24, marginBottom: 5 },
                      ]}
                    >
                      Twitch Streaming Unavailable
                    </Text>
                    <Text
                      style={[
                        deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                          ? AppFontStyle.REGULAR_ANYBODY_12
                          : AppFontStyle.REGULAR_ANYBODY_16,
                        { lineHeight: 20 },
                      ]}
                    >
                      It looks like your Twitch account does not currently meet
                      the requirements to stream directly on Esquadifi. To
                      enable Twitch streaming, you’ll need to be a Twitch
                      Affiliate or
                      <b> Twitch Partner</b>. To reach Affiliate status, your
                      account must have: At least 50 followers A minimum of 8
                      streaming hours over 7 unique days An average of 3
                      concurrent viewers For Partner status, Twitch requires an
                      average of 75 concurrent viewers over 12 days and at least
                      25 hours streamed. Once you meet these criteria, you’ll be
                      eligible to stream on Twitch through our platform. For
                      more information on achieving Affiliate or Partner status,
                      visit Twitch Support​ Twitch Help Portal. StreamScheme
                    </Text>
                  </View>
                </View>
                <View
                  style={{
                    width:
                      deviceSize === DEVICE_SIZES.XS ||
                      deviceSize === DEVICE_SIZES.SM
                        ? "100%"
                        : "48%",
                    justifyContent: "center",
                    // marginLeft:
                    //   deviceSize === DEVICE_SIZES.XS ||
                    //   deviceSize === DEVICE_SIZES.SM
                    //     ? 0
                    //     : 10,
                  }}
                >
                  <View
                    style={{
                      backgroundColor: AppColors.black_121212,
                      padding: 20,
                      borderRadius: 10,
                      width:
                        deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                          ? 300
                          : "auto",
                      alignItems: "center",
                      borderWidth: 1,
                      borderColor: AppColors.gray_9F9F9F,
                    }}
                  >
                    <View
                      style={{
                        // flex: 1,
                        flexDirection: "row",
                        justifyContent: "space-between",
                        gap: 15,
                        alignItems: "center",
                        // paddingHorizontal: 30,
                      }}
                    >
                      <Text
                        style={[
                          deviceSize === DEVICE_SIZES.XS ||
                          deviceSize === DEVICE_SIZES.SM
                            ? AppFontStyle.BOLD_ANYBODY_16
                            : AppFontStyle.BOLD_ANYBODY_20,
                          { flex: 1 },
                        ]}
                      >
                        Connect to YouTube instead
                      </Text>
                      <TouchableOpacity
                        style={{
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        onPress={() => {
                          closePopup();
                        }}
                      >
                        <Image
                          source={AppImages.icCloseWhite}
                          style={{
                            height: 35,
                            width: 35,
                          }}
                        />
                      </TouchableOpacity>
                    </View>
                    <Separator
                      color={AppColors.appBlackColor_1e1e1e}
                      height={2}
                      marginTop={10}
                      marginBottom={10}
                      marginHorizontal={0}
                    />
                    <View
                      style={{
                        paddingHorizontal:
                          deviceSize === DEVICE_SIZES.XS ||
                          deviceSize === DEVICE_SIZES.SM
                            ? 0
                            : 20,
                      }}
                    >
                      <View
                        style={{
                          marginBottom: 20,
                          // width:
                          //   deviceSize === DEVICE_SIZES.XS ||
                          //   deviceSize === DEVICE_SIZES.SM
                          //     ? 250
                          //     : "100%",
                          // height:
                          //   deviceSize === DEVICE_SIZES.XS ||
                          //   deviceSize === DEVICE_SIZES.SM
                          //     ? "auto"
                          //     : 166,
                          padding: 6,
                          backgroundColor: AppColors.appBlackColor_1e1e1e,
                          borderRadius: 10,
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Image
                          style={{
                            width:
                              deviceSize === DEVICE_SIZES.XS ||
                              deviceSize === DEVICE_SIZES.SM
                                ? 150
                                : 243,
                            height: 55,
                            resizeMode: "contain",
                          }}
                          source={AppImages.icYoutubeStreaming}
                        />
                      </View>
                      <View style={{ width: "100%", alignItems: "center" }}>
                        <CommonButton
                          buttonStyle={{
                            backgroundColor: AppColors.appViolentColor_6D08C3,
                            paddingVertical: 12,
                            paddingHorizontal: 24,
                            borderRadius: 5,
                            boxShadow: 0,
                            width: 212,
                          }}
                          textStyle={[AppFontStyle.BOLD_ANYBODY_12, {}]}
                          title={"Connect"}
                          onTap={() => {}}
                        />
                      </View>
                    </View>
                  </View>
                </View>
              </View>
            </View>
          </View>
        </ScrollView>
      </View>
    </Modal>
  );
};

export default ConnetedPopup;
